let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cVk2y")).then(() => parcelRequire('9iWN4'));